
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import './App.css';
import Home from './pages/Login';
import ChatApp from './pages/Home.js';
import Signup from './pages/SignUp.js';
import History from './pages/History.js';
import ContactUs from './pages/Contact.js';
import Waitlist from './pages/Waitlist.js';
import AboutUs from './pages/About.js';
import AdminPage from './pages/Admin.js';
import Donate from './pages/Donate.js';
import Terms from './pages/Terms.js';
import Privacy from './pages/Privacy.js';
import Profile from './pages/Profile.js';
import Download from './pages/Download.js';
function App() {
  return (<>
    <Router>
      <Routes>
        <Route path="/" element={<ChatApp />} />
        <Route path="/login" element={<Home />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/history" element={<History />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/waitlist" element={<Waitlist />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/download" element={<Download />} />
      </Routes>
    </Router>
  </>);
}

export default App;
